import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../Environments/Environment";
import { SearchRoleRequest } from "../Dto/RoleSearchRequest";
import { SearchRoleResponse } from "../Dto/RoleSearchResponse";
import { CreateRoleRequest } from "../Dto/RoleCreateRequest";

@Injectable({ providedIn: "root" })
export class RoleApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async searchRoles(params: SearchRoleRequest): Promise<SearchRoleResponse> {
    const url = new URL("roles", `${this.baseUrl}/`);
    const searchParams = new URLSearchParams();

    if (params.search) {
      searchParams.set("search", params.search);
    }

    if (params.name) {
      searchParams.set("name", params.name);
    }

    if (params.description) {
      searchParams.set("description", params.description);
    }

    if (params.isSystem !== undefined) {
      searchParams.set(
        "isSystem",
        (() => {
          if (params.isSystem) {
            return "true";
          }
          return "false";
        })(),
      );
    }

    if (params.createdAtFrom) {
      searchParams.set("createdAtFrom", params.createdAtFrom);
    }

    if (params.createdAtTo) {
      searchParams.set("createdAtTo", params.createdAtTo);
    }

    if (params.page !== undefined) {
      searchParams.set("page", params.page.toString());
    }

    if (params.limit !== undefined) {
      searchParams.set("limit", params.limit.toString());
    }

    if (searchParams.toString()) {
      url.search = searchParams.toString();
    }

    return await firstValueFrom(this.http.get<SearchRoleResponse>(url.toString(), { withCredentials: true }));
  }

  async setRolePermissions(roleId: string, permissionIds: string[]): Promise<void> {
    await firstValueFrom(this.http.put(`${this.baseUrl}/roles/${roleId}/permissions`, { permissionIds }, { withCredentials: true }));
  }

  async createRole(request: CreateRoleRequest): Promise<void> {
    await firstValueFrom(this.http.post(`${this.baseUrl}/roles`, request, { withCredentials: true }));
  }

  async deleteRole(roleId: string): Promise<void> {
    await firstValueFrom(this.http.delete(`${this.baseUrl}/roles/${roleId}`, { withCredentials: true }));
  }
}
